module.exports = __webpack_public_path__ + "img/1.15dd3cce.png";